import {useCallback, useEffect, useState} from 'react';

export function useBonusProgressBarBBB({fqv}: any) {
  const [progressArray, setProgressArray] = useState([]);

  const progressBarArray: any = [];

  const calculateProgressValue = useCallback(() => {
    const formattedFQV = !isNaN(Number(fqv)) ? Number(fqv) : 0;
    const maxIndexValue = 5;
    const progressRangeArray = [
      {min: 0, max: 1199.99},
      {min: 1200, max: 3599.99},
      {min: 3600, max: 5999.99},
      {min: 6000, max: 9999.99},
      {min: 10000, max: 10000},
    ];
    for (let i = 0; i < maxIndexValue; i++) {
      let progress;
      if (formattedFQV === 10000) {
        progress = 10000;
      } else if (
        formattedFQV !== 10000 &&
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        formattedFQV >= progressRangeArray[i].min
      ) {
        progress =
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          ((formattedFQV - progressRangeArray[i].min) /
            // @ts-expect-error TS(2532): Object is possibly 'undefined'.
            (progressRangeArray[i].max - progressRangeArray[i].min)) *
          100;
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
      } else if (formattedFQV < progressRangeArray[i].min) {
        progress = 0;
      }
      progressBarArray.push({
        num: i,
        progress:
          // @ts-expect-error TS(2532): Object is possibly 'undefined'.
          formattedFQV <= progressRangeArray[i].max
            ? progress
            : // @ts-expect-error TS(2532): Object is possibly 'undefined'.
              progressRangeArray[i].max,
      });
    }
    setProgressArray(progressBarArray);
  }, [fqv]);

  useEffect(() => {
    calculateProgressValue();
  }, [calculateProgressValue]);

  return {progressArray};
}
